import React, {useEffect} from 'react';
import ModalForm from '../../../../components/modalComponents/ModalForm';
import InputText from '../../../../components/modalComponents/InputText';
import InputUploadFile from '../../../../components/modalComponents/InputUploadFile';
import {
    getAllCargosWithTodosOptionAPI,
    getDivisionesAPI,
    getPlantillasBeneficiosAPI, getAllJornadasLaboralesAPI
} from '../../../../consumers/backendApisUrls';
import InputDate from '../../../../components/modalComponents/InputDate';
import {EXTENSION_PDF, OPERADORES_COMPARACION} from '../../../../constants/hardCodedConstants';
import InputSelect from '../../../../components/modalComponents/InputSelect';
import {useGetOptionsSelect} from '../../../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import {
    handleFind, handleFindDropdownMultiSelected,
    handleFindDropdownSelected,
    initialAllOptionPromises,
    isNullOrUndefinded
} from '../../../../helper/utils';
import Select from "react-select";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import InputBool from '../../../../components/modalComponents/InputBool';
const BaseCampana = ({
                         toggleModal,
                         handleSubmit,
                         puedeEditar,
                         title,
                         sectionName,
                         filas,
                         setFilas,
                         allDropdowns,
                         setAllDropdowns,
                         formValues,
                         setFormValues,
                         commonProps,
                         selectProps,
                         isLoading,
                         setIsLoading,
                         isUploading,
                         setIsUploading,
                         KEYS,
                     }) => {
    const SECTION_NAME = sectionName;
    const KEYS_DROPDOWN = ["IdPlantilla", "IdUnidad", "IdCargo","IdTipoEmpleado"];
    const [getOption] = useGetOptionsSelect();

    const getDropdowns = async () => {
        setIsLoading(true);
        const dropdownsPromises = () => [
            getOption(getPlantillasBeneficiosAPI()),
            getOption(getDivisionesAPI()),
            getOption(getAllCargosWithTodosOptionAPI()),
            getOption(getAllJornadasLaboralesAPI())
        ];
        await initialAllOptionPromises(
            dropdownsPromises,
            KEYS_DROPDOWN,
            handleDropdowns
        );
        setIsLoading(false);
    };

    const handleDropdowns = (data) => {
        const incluye = {
            key: "Incluye",
            value: [
                {value: "0", label: "No incluye"},
                {value: "1", label: "Incluye"},
            ],
        };
        const cuotas = {
            key: "CuotasMax",
            value: Array.from({ length: 6 }, (_, i) => ({
                value: i + 1,     
                label: `${i + 1}`, 
            })),
        };
        const signosComparativos = {
            key: "SignoComparador",
            value: [
                {value: 'mayor', label: '>'},
                {value: 'menor', label: '<'},
                {value: 'menorIgual', label: '<='},
                {value: 'mayorIgual', label: '>='},
            ],
        };        
        data.push(incluye);
        data.push(cuotas);
        data.push(signosComparativos);
        setAllDropdowns(data);
    };

    const handleChangeFilas = (e, key, index) => {
        if (!isNullOrUndefinded(e?.value)) {
            const newFilas = [...filas];
            newFilas[index][key] = e.value;
            setFilas(newFilas);
        }
    };

    const handleChangeFilasMiltiSelect = (e, key, index) => {
        if (!isNullOrUndefinded(e)) {
            const newFilas = [...filas];
            newFilas[index][key] = Array.isArray(e) ? e.map(x => x.value) : [];
            setFilas(newFilas);
        }
    };

    const init = async () => {
        getDropdowns();
    };

    useEffect(() => {
        init();
    }, []);



    return (
        <ModalForm
            onSubmit={handleSubmit}
            showModal={toggleModal}
            width="1200px"
            titulo={title}
            saveButtonDisabled={isLoading}
            isSubmitting={isLoading}>
            <div className="row">
                <div className="col-md-6">
                    <InputText
                        label="Nombre"
                        {...commonProps(KEYS.Nombre)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">                    
                    <InputBool 
                        label="Requiere datos externos" 
                        textInput="No / Sí" {...commonProps(KEYS.RequiereDataExterna)} 
                        colLabel={6} colInput={6} 
                        direction="column"
                        isDisabled={false}/>                    
                </div>
                <div className="col-md-6">
                    <InputBool
                        label="Solicitar número de WhatsApp"
                        textInput="No / Sí"
                        {...commonProps(KEYS.SolicitarNumeroWhatsApp)}
                        colLabel={6} colInput={6}
                        direction="column"
                        isDisabled={!puedeEditar || isLoading}/>
                </div>
                <div className="col-md-6">
                    <InputSelect
                        label="Cuotas descuento planilla"
                        {...selectProps(KEYS.CuotasMax)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputText type="number"
                        label="Día de corte"
                        {...commonProps(KEYS.DiaCorte)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputDate
                        label="Fecha de inicio"
                        {...commonProps(KEYS.FechaInicio)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputDate
                        label="Fecha de fin"
                        {...commonProps(KEYS.FechaFin)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputText
                        label="Fecha Envio"
                        {...commonProps(KEYS.FechaEnvio)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>
                <div className="col-md-6">
                    <InputText
                        label="Vigencia del pedido"
                        {...commonProps(KEYS.VigenciaPedido)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>

                <div className="col-md-6">
                    <InputText
                        label="Máximo cuotas en meses"
                        {...commonProps(KEYS.MesesMaximoCuotas)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                        isRequired={true}
                    />
                </div>
                <div className="col-md-6">
                    <InputUploadFile
                        label="Lineamientos"
                        name={KEYS.Lineamientos}
                        uploadFile={formValues[KEYS.Lineamientos]}
                        setUploadFile={(res) =>
                            setFormValues({...formValues, [KEYS.Lineamientos]: res})
                        }
                        sectionName={SECTION_NAME}
                        setIsUploading={setIsUploading}
                        validExtensions={EXTENSION_PDF}
                        isDisabled={!puedeEditar || isLoading || isUploading}
                        direction="column"
                        isRequired={true}
                        NoFileMessage={isUploading ? "Subiendo archivo..." : "No se ha subido archivo"}
                    />
                </div>
                
                <div className="col-md-6">
                    <InputText
                        label="Texto descriptivo"
                        {...commonProps(KEYS.TextoDescriptivo)}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                        isRequired={true}
                    />
                    
                </div>
                <div className="col-md-6">
                    <InputUploadFile
                        label="Imagen Campaña"
                        name={KEYS.ImagenCampania}
                        uploadFile={formValues[KEYS.ImagenCampania]}
                        setUploadFile={(res) =>
                            setFormValues({...formValues, [KEYS.ImagenCampania]: res})
                        }
                        sectionName={SECTION_NAME}
                        setIsUploading={setIsUploading}
                        validExtensions={["jpg","jpeg","png"]}                        
                        isDisabled={!puedeEditar || isLoading || isUploading}
                        direction="column"
                        isRequired={true}
                        NoFileMessage={isUploading ? "Subiendo imagen..." : "No se ha subido imagen"}
                    />
                </div>

                <div className="col-md-12">
                    <InputSelect
                        label="Plantilla"
                        {...selectProps(KEYS.IdPlantilla)}
                        sectionName={SECTION_NAME}
                        isDisabled={!puedeEditar || isLoading}
                        direction="column"
                    />
                </div>
                <div className="col-md-12">
                    &nbsp;
                </div>
            </div>
            {puedeEditar && (
                <div className="row pb-3">
                    <div className="col text-right">
                        <button
                            className="btn btn-primary generic-button-ficha-modal "
                            onClick={(e) => {
                                e.preventDefault();
                                setFilas([...filas, {}]);
                            }}>
                            Agregar
                        </button>
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col">
                    {/* <table className="table table-hover table-bordered"> style={{padding: '0px;'}} */}
                    <table className="table table-hover table-bordered" >
                        <thead className="listar-thead">
                            <tr className="font-gothan-medium">
                                <th className="text-center col-sm-3" style={{padding: '0'}}>Unidad</th>
                                <th className="table-center col-md-2">Incluye</th>
                                <th className="table-center col-md-3">Cargo</th>
                                <th className='table-center col-md-2'>Tipo Empleado</th>
                                <th className="table-center col-md-1">Tope</th>
                                <th className="table-center col-md-2">Operador</th>
                                <th className="table-center col-md-1">Fecha Ingreso</th>
                                <th className="table-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="listar-tbody">
                        {filas &&
                            filas.map((row, i) => {
                                return (
                                    <tr key={`${i}`}>
                                        <td className="">
                                            <div style={{ width: "200px" }}>
                                                <Select
                                                    className="font-size-search-label-text"
                                                    placeholder="Seleccionar"
                                                    value={handleFindDropdownMultiSelected(
                                                        allDropdowns,
                                                        row,
                                                        KEYS.IdUnidad
                                                    )}
                                                    options={handleFind(allDropdowns, KEYS.IdUnidad)}
                                                    onChange={(e) =>
                                                        handleChangeFilasMiltiSelect(e, KEYS.IdUnidad, i)
                                                    }
                                                    isMulti={true}
                                                    isClearable
                                                    isDisabled={!puedeEditar || isLoading}
                                                />
                                            </div>
                                            
                                        </td>
                                        <td className="">
                                            <div style={{ width: "130px" }}>
                                                <Select
                                                    className="font-size-search-label-text"
                                                    placeholder="Seleccionar"
                                                    value={handleFindDropdownSelected(
                                                        allDropdowns,
                                                        row,
                                                        KEYS.Incluye
                                                    )}
                                                    options={handleFind(allDropdowns, KEYS.Incluye)}
                                                    onChange={(e) =>
                                                        handleChangeFilas(e, KEYS.Incluye, i)
                                                    }
                                                    isMulti={false}
                                                    isClearable
                                                    isDisabled={!puedeEditar || isLoading}
                                                />
                                            </div>
                                            
                                        </td>
                                        <td className="">
                                            <div style={{ width: "200px" }}>
                                                <Select
                                                    className="font-size-search-label-text"
                                                    placeholder="Seleccionar"
                                                    value={handleFindDropdownMultiSelected(
                                                        allDropdowns,
                                                        row,
                                                        KEYS.IdCargo
                                                    )}
                                                    options={handleFind(allDropdowns, KEYS.IdCargo)}
                                                    onChange={(e) =>
                                                        handleChangeFilasMiltiSelect(e, KEYS.IdCargo, i)
                                                    }
                                                    isMulti={true}
                                                    isClearable
                                                    isDisabled={!puedeEditar || isLoading}
                                                />
                                            </div>
                                            
                                        </td>
                                        
                                        {/* Nuevo filtro -> Tipo de Empleado */}
                                        <td className="">
                                            <div style={{ width: "140px" }}>
                                                <Select
                                                    className="font-size-search-label-text"
                                                    placeholder="Seleccionar"
                                                    value={handleFindDropdownSelected(
                                                        allDropdowns,
                                                        row,
                                                        KEYS.IdTipoEmpleado
                                                    )}
                                                    options={handleFind(allDropdowns, KEYS.IdTipoEmpleado)}
                                                    onChange={(e) =>
                                                        handleChangeFilas(e, KEYS.IdTipoEmpleado, i)
                                                    }
                                                    isMulti={false}
                                                    isClearable
                                                    isDisabled={!puedeEditar || isLoading}
                                                />
                                            </div>
                                            
                                        </td>


                                        <td className="">
                                            <div style={{ width: "80px" }}>
                                                <input
                                                    type="number"
                                                    //className="form-control"
                                                    className="form-control font-size-search-label-text" 
                                                    value={row.Tope || ""}
                                                    onChange={(e) =>
                                                        handleChangeFilas(e.target, "Tope", i)
                                                    }
                                                    disabled={!puedeEditar || isLoading}
                                                />
                                            </div>
                                            
                                        </td>
                                        <td className="">
                                            <div style={{ width: "100px" }}>
                                                <Select
                                                    className="font-size-search-label-text"
                                                    placeholder="Seleccionar"
                                                    value={handleFindDropdownSelected(
                                                        allDropdowns,
                                                        row,
                                                        KEYS.SignoComparador
                                                    )}
                                                    options={handleFind(allDropdowns, KEYS.SignoComparador)}
                                                    onChange={(e) =>
                                                        handleChangeFilas(e, KEYS.SignoComparador, i)
                                                    }
                                                    isMulti={false}
                                                    isClearable
                                                    isDisabled={!puedeEditar || isLoading}
                                                />
                                            </div>
                                            

                                        </td>
                                        <td className="">
                                            <div style={{ width: "140px" }}>
                                                <input 
                                                    type='date'
                                                    className="form-control font-size-search-label-text" 
                                                    name={KEYS.FechaIngreso} 
                                                    value={row.FechaIngreso ?? ""}
                                                    onChange={(e) =>
                                                        handleChangeFilas(e.target, "FechaIngreso", i)
                                                    }
                                                    disabled={!puedeEditar || isLoading}
                                                />
                                            </div>                                            
                                        </td>
                                        <td className="text-center">
                                            {puedeEditar && (
                                                <FontAwesomeIcon
                                                    icon="trash"
                                                    className="hand-pointer"
                                                    title="Eliminar"
                                                    onClick={() => {
                                                        const newFilas = [...filas];
                                                        newFilas.splice(i, 1);
                                                        setFilas(newFilas);
                                                    }}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <p
                        className="ficha-form-input-validation-message"
                        id={`ficha-edit-${SECTION_NAME}-Topes-validation-message`}></p>
                </div>
            </div>
        </ModalForm>
    );
};

export default BaseCampana;